import * as React from "react";
import { useHistory } from "react-router";
import { Icon } from "@fluentui/react/lib/Icon";
import { Fabric } from "@fluentui/react/lib/Fabric";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/Dialog";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { useDispatch, useSelector } from "react-redux";

import LogoImage from "../logo-image-ici/LogoImage";
import { ROUTE } from "../../shared/constants/routes";
import { TEXT } from "../../shared/constants/texts";
import { resetLoginState } from "../../containers/login/redux/slice";

import ConfigService from "../../shared/services/configService";
import SessionService from "../../shared/services/sessionService";
import { revokeIcmAuthTokenApiCall } from "../../containers/login/redux/apiCalls";

const sessionService = new SessionService();
const configService = new ConfigService();

const Header: React.FC<any> = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = React.useState(false);
  const history = useHistory();
  const state = useSelector((state: any) => state.addToIciSlice);
  const { isAdvancePageEnabled } = state;

  const onLogoutClickedHandler = () => {
    const isIdpEnabled = configService.getOauthFlag().toString();
    let logoutUrl = "";
    if (isIdpEnabled === "false") {
      let icmUrl = configService.getIcmUrl();
      if (icmUrl.endsWith("/")) {
        icmUrl = icmUrl.slice(0, -1);
      }
      const token = sessionService.getAuthToken();
      const refreshToken = sessionService.getIcmRefreshToken();
      revokeIcmAuthTokenApiCall({
        dispatch: dispatch,
        history: history,
        requestData: {
          refreshToken: refreshToken,
          token: token,
        },
      });
      let signOutUrl = configService.getSignOutUrl().toString();
      logoutUrl = icmUrl + "/" + signOutUrl;
    } else {
      const idTokenIdp = sessionService.getIdpIdToken();
      logoutUrl = window.location.origin + `/Taskpane/GetLogoutUri?idToken="${idTokenIdp}`;
    }
    Office.context.ui.displayDialogAsync(
      logoutUrl,
      { height: 70, width: 40, promptBeforeOpen: false },
      (asyncResult) => {
        if (asyncResult && asyncResult.value) {
          const dialog = asyncResult.value;
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (response) => addEventHandler(response));
          dialog.addEventHandler(Office.EventType.DialogEventReceived, (response) => addEventHandler(response));
          sessionService.resetSession();
          dispatch(resetLoginState());
          history.push(ROUTE.LOG_OUT_ICI);
        } else {
          console.log("logout failed with error:", asyncResult);
          sessionService.resetSession();
          dispatch(resetLoginState());
          history.push(ROUTE.LOG_OUT_ICI);
        }
      }
    );
  };

  const addEventHandler = (_response) => {};

  const onEnterPressSignOut = (e) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      onSignOutHandler();
    }
  };

  const onSignOutHandler = () => {
    setIsOpen(true);
  };

  const imgSrc = "assets/images/icertis-logo/icertis-logo-horiz-on-white-60px.png";

  return (
    <React.Fragment>
      <div
        className="header-container"
        style={isAdvancePageEnabled ? { marginLeft: "1rem", marginRight: "1rem", width: "calc(100vw - 2rem" } : {}}
      >
        <div className="logo-container">
          <LogoImage logoImage={imgSrc} />
        </div>
        <div
          tabIndex={1}
          className="sign-out-icon-container"
          title={TEXT.SIGN_OUT}
          onClick={onSignOutHandler}
          onKeyDown={onEnterPressSignOut}
        >
          <Icon iconName="SignOut" />
          <span className="sr-only">{TEXT.SIGN_OUT}</span>
        </div>
      </div>
      <Fabric className="App">
        <Dialog
          isOpen={isOpen}
          type={DialogType.close}
          onDismiss={close.bind(this)}
          title="Confirm Logout"
          subText=""
          isBlocking={false}
          closeButtonAriaLabel="Close"
        >
          <p>{TEXT.LOGOUT_CONFIRMATION_MESSAGE}</p>
          <DialogFooter>
            <DefaultButton className="btn-primary" onClick={onLogoutClickedHandler}>
              {TEXT.YES}
            </DefaultButton>
            <DefaultButton className="btn-secondary" onClick={() => setIsOpen(false)}>
              {TEXT.NO}
            </DefaultButton>
          </DialogFooter>
        </Dialog>
      </Fabric>
    </React.Fragment>
  );
};

export default Header;
